export default {
  namespaced: true,
  state: {
    status: {
      code: null
    },
    inProgress: null
  },
  getters: {
    getStatus(state) {
      return state.status
    },
    getStatusInProgress(state) {
      return state.inProgress
    },
  },
  mutations: {
    setStatus(state, status) {
      state.status = {
        code: status.status,
        ...status
      }
      delete state.status.status
    },
    setStatusMessage(state, statusMessage) {
      state.status.message = statusMessage
    },
    setStatusInProgress(state, { user, offer }) {
      state.inProgress = !!(offer && offer.status === 'in_progress')
      if (user.kyc.id_card_verification_is_done && !user.kyc.id_card_image_verified) {
        state.status.message = `${user.name} 사장님! 고객확인의무에 따른 자격여부를 검증하고 있습니다. 약 1영업일 이내 처리 될 예정입니다.`
        return
      }

      if (state.status.code !== 'no_cfa_account') {
        if (state.inProgress) {
          state.status.message = `${user.name} 사장님! 외부기관으로부터 고객님 매출 정보를 확인 중입니다.`
          if (state.status.code === 'executed_still') {
            state.status.message = `${user.name} 사장님! 먼저 신청한 고객님의 <b>추가비상금을</b> 산출하고 있습니다. 조금만 기다려 주세요`
          }
        }
      }
    }
  },
  actions: {
    setStatus({ commit }, status) {
      commit('setStatus', status)
    },
    setStatusMessage({ commit }, statusMessage) {
      commit('setStatusMessage', statusMessage)
    },
    setStatusInProgress({ commit }, { user, offer }) {
      commit('setStatusInProgress', { user, offer })
    },
  }
}
